module.exports = __webpack_public_path__ + "img/ring_y_s_1_0.9f3dd0ab.png";